import { useGetServicesQuery } from '../api';
import { serviceItemListTransformer } from '../helpers/item-list-transformer';

export function useServicesList() {
  const { data: services, isLoading } = useGetServicesQuery();
  const transformed = services?.map(serviceItemListTransformer) ?? [];
  return { data: transformed, isLoading };
}
